'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerButton = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  & > span {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: rgba(0,0,0,0.9);\n    width: 100%;\n    height: 100%;\n    display: grid;\n    align-items: center;\n    justify-items: center;\n  }\n  & > div {\n    background: url(https://www.tutellus.com/dist/images/play-button2.svg) no-repeat;\n    background-size: cover;\n    width: ', ';\n    height: ', ';\n    cursor: pointer;\n    margin: 0 auto;\n\n    &:hover {\n      opacity: .5;\n    }\n  }\n'], ['\n  & > span {\n    position: absolute;\n    top: 0;\n    left: 0;\n    background: rgba(0,0,0,0.9);\n    width: 100%;\n    height: 100%;\n    display: grid;\n    align-items: center;\n    justify-items: center;\n  }\n  & > div {\n    background: url(https://www.tutellus.com/dist/images/play-button2.svg) no-repeat;\n    background-size: cover;\n    width: ', ';\n    height: ', ';\n    cursor: pointer;\n    margin: 0 auto;\n\n    &:hover {\n      opacity: .5;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Toggle = require('./Toggle');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/*:: import type {ComponentType} from 'react' */


var PlayerButton = exports.PlayerButton = (0, _styledComponents2.default)(function (props) {
  return _react2.default.createElement(
    _Toggle.Toggle,
    null,
    function (isPlaying, togglePlayer) {
      return _react2.default.createElement(
        'div',
        { className: props.className, onClick: togglePlayer },
        isPlaying ? _react2.default.createElement(
          'span',
          null,
          props.children
        ) : _react2.default.createElement('div', null)
      );
    }
  );
})(_templateObject, function (props) {
  return props.size || '1em';
}, function (props) {
  return props.size || '1em';
});
PlayerButton.displayName = 'PlayerButton';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/PlayerButton.js
// module id = 655
// module chunks = 0